module.exports = __webpack_public_path__ + "img/no2.951f220d.png";